import { render, staticRenderFns } from "./AppLandingCardTopApps.vue?vue&type=template&id=23f944bb&scoped=true&"
import script from "./AppLandingCardTopApps.vue?vue&type=script&lang=js&"
export * from "./AppLandingCardTopApps.vue?vue&type=script&lang=js&"
import style0 from "./AppLandingCardTopApps.vue?vue&type=style&index=0&id=23f944bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f944bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VScrollXTransition,VSkeletonLoader})
